// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type IstatGenerationParametersFragment = { __typename?: 'IstatGenerationParametersDTO', availableBeds: number, availableRooms: number, availableToilets: number };

export const IstatGenerationParametersFragment = gql`
    fragment IstatGenerationParameters on IstatGenerationParametersDTO {
  availableBeds
  availableRooms
  availableToilets
}
    `;
/* eslint-enable */